"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useWaveData } from "@/hooks/useWaveData";
import { useQuery } from "@tanstack/react-query";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { DROP_DETAIL_STALE_TIME_MS } from "@/services/api/drop-api";
import { fetchDropV2ById } from "@/services/api/wave-drops-v2-api";
export const useSingleWaveDropData = (initialDrop, onClose) => {
  const $ = _c(15);
  let t0;
  if ($[0] !== initialDrop.id) {
    t0 = {
      queryKey: [QueryKey.DROP, {
        drop_id: initialDrop.id,
        view: "single-wave-drop"
      }],
      queryFn: t1 => {
        const {
          signal
        } = t1;
        return fetchDropV2ById(initialDrop.id, signal, {
          includeTopRaters: false
        });
      },
      staleTime: DROP_DETAIL_STALE_TIME_MS
    };
    $[0] = initialDrop.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: drop
  } = useQuery(t0);
  let t1;
  if ($[2] !== onClose) {
    t1 = () => {
      onClose();
    };
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onWaveNotFound = t1;
  const t2 = drop?.wave.id ?? null;
  let t3;
  if ($[4] !== onWaveNotFound || $[5] !== t2) {
    t3 = {
      waveId: t2,
      onWaveNotFound
    };
    $[4] = onWaveNotFound;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: wave
  } = useWaveData(t3);
  let t4;
  if ($[7] !== drop || $[8] !== initialDrop.stableHash || $[9] !== initialDrop.stableKey) {
    t4 = drop ? {
      type: DropSize.FULL as const,
      ...drop,
      stableHash: initialDrop.stableHash,
      stableKey: initialDrop.stableKey
    } : null;
    $[7] = drop;
    $[8] = initialDrop.stableHash;
    $[9] = initialDrop.stableKey;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const extendedDrop = t4;
  let t5;
  if ($[11] !== drop || $[12] !== extendedDrop || $[13] !== wave) {
    t5 = {
      drop,
      wave,
      extendedDrop
    };
    $[11] = drop;
    $[12] = extendedDrop;
    $[13] = wave;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};